/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DEFAULT_APP_CONFIG = {
  SIGNER_PK:
    "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDiJCMYuJV+bvs8GxMaOMFtks+q\nq4S+NWIaTLcGYYd4d/CU2qXsl0Hp6LMRa4bLXJyHbkXTWpLsLqWn/RvKcvYvm9vj\ncJQe2m4tIokcdDnqMPRxSWPG7l4AP0GPV2mLu4fIMuG8YFbzip4yG/28vS72NSB/\ns5ir8R0IyCCHoSDFXQIDAQAB\n-----END PUBLIC KEY-----",
  defaultLoading: {
    image: "https://i.ibb.co/0sLwPKt/Tribe-Footer-removebg-preview.png",
    titleNormalText: "Loading",
    titleBoldText: "Page...",
    description: "This might take few seconds, Please wait !",
  },
  platformSemantics: {
    semantics: {
      holder: "Users",
      holders: "Users",
      issuer: "Organization",
    },
    Holders: {
      title: "Users",
    },
    HoldersGroups: {
      title: "Users Group",
    },
    DashboardIssuerAnalysis: {
      title: "Organization",
    },
  },
  mqttService: {
    // MQTT_BROKER_URL: "wss://j1iust.stackhero-network.com/", // Staging server
    // MQTT_BROKER_URL: "mqtts://e26tlf.stackhero-network.com/", // Production Server
    // MQTT_USERNAME: "scooby-client",
    // MQTT_PASSWORD: "ncenFaRI64YX6S5gRUt71Ngs77VW4R6X",
    MQTT_BROKER_URL: "mqtts://yq43m9.stackhero-network.com:13686/", // Staging server
    MQTT_USERNAME: "scooby-client",
    MQTT_PASSWORD: "UEfuqxxlF6mtGxL7VJieodlUlhqgTCox",
  },
};
